import challengeStyles from "../../common/css/Challenge.module.css";
import commonStyles from "../../common/css/Common.module.css";
import EnterItem from "../common/EnterItem";
import MyPageEnter from "./MyPageEnter";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Url from "../../common/Url";
import {emailPattern, namePattern} from "../../Utils/ValidateUtils";
import {FormInputHelper} from "../../common/php_lib/form-input-helper";
import ResetPasswordMd from "./ResetPasswordMd";
import {Loading} from "../../routes/basic/Unknown";
import useKeepDoubleClick from "../../common/hook/useKeepDoubleClick";
import {useAuth} from "../../common/hook/AuthContext";
import {useDialog} from "../../common/hook/DialogContext";
import { useTranslation } from "react-i18next";

const MyPageInfo = () => {
    const { isLogin, loginCheck, setIsLogin } = useAuth();
    const [userData, setUserData] = useState({
        userId: '',
        userName: '',
        email: '',
        dept: '',
        position: '',
        isClinician: ''
    });
    const navigate = useNavigate();
    const [clicked, preventDoubleClick] = useKeepDoubleClick();
    const [resetPasswordMdOpen, setResetPasswordMdOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {addAlert, addConfirm} = useDialog();
    const {t} = useTranslation();

    const inputChange = (event) => {
        const { name, value } = event.target;
        setUserData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const isClinicianChange = (event) => {
        setUserData(prevState => ({
            ...prevState,
            ['isClinician']: event.target.value === "true" ? true : false
        }));
    };


    const getUserInfo = () => {
        setIsLoading(true);
        fetch(`/v1/users/info`)
            .then((response) => {
                if (response.ok) {
                    setIsLoading(false);
                    return response.json();
                } else {
                    return response.json().then(json => {
                        addAlert(
                            json.message,
                            () => navigate(Url.login)
                            // () => navigate(Url.home)
                        );
                    })
                }
            })
            .then((json) => {
                setUserData(json);
            });
    }

    useEffect(() => {
        if (isLogin === false) {
            setIsLoading(true);
            addAlert(
                t("msg.error.login"),
                () => navigate(Url.login)
            );
        } else {
            getUserInfo();
        }
    }, []);

    const updateData = () => {
        addConfirm(
            t("msg.info.reqMyInfo"),
            () => {
                fetch(`/v1/users`, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    method: "put",
                    credentials: "include",
                    redirect: "follow",
                    body: JSON.stringify(userData),
                }).then((response) => {
                    clicked.current = false;
                    if (response.ok) {
                        addAlert(
                            t("msg.info.finishUpdate"),
                            () => getUserInfo()
                        );

                    } else if (response.status === 400) {
                        response.json().then(json => {
                            addAlert(json.message);
                        })
                    } else if (response.status === 401) {
                        response.json().then(json => {
                            setIsLoading(true);
                            setIsLogin(false);
                            addAlert(json.message, () => navigate(Url.login));
                        })
                    }else {
                        throw new Error(t("msg.error.failUpdate"));
                    }
                }).catch(e => {
                    addAlert(e.message);
                });
            },
            () => clicked.current = false
        )

    };

    const validation = () => {
        if (!namePattern.test(userData.userName) || !userData.userName) {
            addAlert(t("msg.valid.wrongName"));
            return false;
        }
        if (!emailPattern.test(userData.email) || !userData.email) {
            addAlert(t("msg.valid.wrongEmail"));
            return false;
        }

        return true;
    };

    const submit = () => {
        preventDoubleClick(updateData, validation);
    };

    useEffect(() => {
        FormInputHelper.initKeyUpChecker();
        FormInputHelper.initKeyDownChecker();
        FormInputHelper.initCharacterLimiter();
    }, []);

    return (
        <>
            {!isLoading ?
                <div className={challengeStyles.mypage_enter_box}>
                    <div className={`${commonStyles.enter_wrap} ${challengeStyles.enter_wrap}`}>
                        <EnterItem addClass={challengeStyles.enter_item}>
                            <MyPageEnter
                                id={"user_id"}
                                type={"text"}
                                readOnly={true}
                                label={t("common.id")}
                                value={userData.userId}
                            />
                        </EnterItem>
                        <EnterItem addClass={challengeStyles.enter_item}>
                            <MyPageEnter
                                id={"user_name"}
                                type={"text"}
                                label={t("common.name")}
                                name={"userName"}
                                value={userData.userName}
                                inputChange={(e) => inputChange(e)}
                                maxLength={30}
                                dataType={"user_name"}
                            />
                        </EnterItem>
                        <EnterItem addClass={challengeStyles.enter_item}>
                            <MyPageEnter
                                id={"user_email"}
                                type={"text"}
                                label={t("common.email")}
                                name={"email"}
                                value={userData.email}
                                inputChange={(e) => inputChange(e)}
                                maxLength={50}
                                dataType={"email_address"}
                            />
                        </EnterItem>
                        <EnterItem addClass={challengeStyles.enter_item}>
                            <MyPageEnter
                                id={"user_team"}
                                type={"text"}
                                label={t("common.dept")}
                                name={"dept"}
                                value={userData.dept}
                                inputChange={(e) => inputChange(e)}
                                maxLength={50}
                            />
                        </EnterItem>
                        <EnterItem addClass={challengeStyles.enter_item}>
                            <MyPageEnter
                                id={"user_position"}
                                type={"text"}
                                label={t("common.agent")}
                                name={"position"}
                                value={userData.position}
                                inputChange={(e) => inputChange(e)}
                                maxLength={50}
                            />
                        </EnterItem>

                        <EnterItem addClass={challengeStyles.enter_item}>
                            <div className={`${commonStyles.item_title} ${challengeStyles.item_title}`}>{t("mypage.info.docYn")}</div>
                            <div className={`${commonStyles.enter} ${challengeStyles.enter} ${commonStyles.flex} ${challengeStyles.flex}`}>
                                <div className={`${commonStyles.radio_item} ${challengeStyles.radio_item}`}>
                                    <label>
                                        <input type="radio" onChange={isClinicianChange} value={"true"} checked={userData.isClinician} />
                                        <span>{t("mypage.info.docY")}</span>
                                    </label>
                                </div>
                                <div className={`${commonStyles.radio_item} ${challengeStyles.radio_item}`}>
                                    <label>
                                        <input type="radio" onChange={isClinicianChange} value={"false"} checked={!userData.isClinician} />
                                        <span>{t("mypage.info.docN")}</span>
                                    </label>
                                </div>
                            </div>
                        </EnterItem>
                    </div>
                    <div className={`${commonStyles.bottom_btn_wrap} ${challengeStyles.bottom_btn_wrap}`}>
                        <button
                            type="button"
                            className={`${commonStyles.cc_btn} ${challengeStyles.cc_btn}`}
                            onClick={submit}
                        >
                            <span>{t("mypage.info.update")}</span>
                        </button>
                        <button
                            className={`${commonStyles.reset_password} ${challengeStyles.reset_password}`}
                            onClick={() => setResetPasswordMdOpen(true)}
                        >
                            <span>{t("mypage.info.pw")}</span>
                        </button>
                    </div>
                </div>
                :
                <Loading />
            }

            <ResetPasswordMd
                open={resetPasswordMdOpen}
                closedMd={() => setResetPasswordMdOpen(false)}
                setIsLogin={setIsLogin}
            />
        </>
    );
};

export default MyPageInfo;